;
define("pickup_in_store.tpl", function(){});

